<script lang="ts">
	import { yyyy, zzzz } from "../store.svelte";
	import { onMount, onDestroy } from "svelte";
	import { fly, fade } from "svelte/transition";
	import Info from "./idented/Info.svelte";
	import Comments from "./idented/Comments.svelte";
	import FindEnergized from "./idented/FindEnergized.svelte";
	import Nrgy from "./idented/Nrgy.svelte";
	import Fa from "svelte-fa";
	import {
		faPlugCircleBolt,
		faCalculator,
		faTableList,
		faDiagramProject,
		faComments,
		faArrowRight,
		faArrowLeft,
		faPlus,
		faPlugCircleXmark,
		faPlugCircleExclamation,
		faPowerOff,
	} from "@fortawesome/free-solid-svg-icons";

	let ready: boolean = $state(false);
	let { found = $bindable(), i = $bindable() } = $props();
	let displayed: string = $state("");

	let display = (item: string) => {
		displayed = item;
	};

	let showMore: boolean = $state(false);
	let makeLarge = () => {
		console.log('makeLarge')
		zzzz.emit("makeLarge", found);
	};

	let makeSmall = () => {
		zzzz.emit("makeSmall");
	};

	let expandMe = () => {
		let _ = yyyy.map.idnt.map((item) => ({
			...item,
			expanded: item.uniqueId === found.uniqueId,
		}));

		yyyy.map.idnt = _;
		displayed = "INFO";
		showMore = true;
	};

	let condenseMe = () => {
		let _ = yyyy.map.idnt.map((item) => ({
			...item,
			expanded: true,
		}));
		showMore = false;
		yyyy.map.idnt = _;
	};

	let addToOutages = () => {
		// Generate a unique ID for this outage
		const outageId = `outage-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
		
		// Create outage object
		const outage = {
			_: outageId,
			iama: found.layer.type === 'line' ? 'EDGE' : 'NODE',
			lw_table: found.properties.lw_table,
			lw_id: found.properties.lw_id,
			phase: found.properties.phase || 'UNKNOWN',
			lw_table_pkid: found.properties.lw_table_pkid,
			feeder_id: found.properties.feederid,
			clkd: found.clicked || { lat: 0, lng: 0 },
			duration: null,
			status: found.properties.status
		};
		
		// Add to outages array
		yyyy.outages.push(outage);
		
		// Notify map to update outage markers
		zzzz.emit("outages-updated");
		
		// Flash highlight
		zzzz.emit("makeLarge", found);
		setTimeout(() => zzzz.emit("makeSmall"), 1500);
		yyyy.map.idnt = [];
	};

	onMount(() => {
		ready = true;
		console.log('<<<<<<<', found)
	});

	onDestroy(() => {});
</script>
<div style="display: none;" >Idented.svelte </div>
{#if ready}
	<div
		class="device-card"
		onmouseenter={makeLarge}
		onmouseleave={makeSmall}
		in:fly={{ x: -200, duration: 175  }}
		out:fly={{ y: 200, duration: 175  }}
	>
		<div class="device-header">
			{#if showMore}
				<span onclick={condenseMe} style="cursor:pointer; color: #ff3e00;">
					<Fa icon={faArrowLeft} size="1.5x" />
				</span>
			{/if}
			<span class="device-label">{found.properties.lw_table}</span>
			{#if found.properties.phase}
				<span class="device-phase phase-{found.properties.phase.toLowerCase()}">{found.properties.phase}</span>
			{/if}
		</div>

		<div class="device-content">
			<div class="device-property">
				<span class="property-label">ID:</span>
				<span class="property-value id-value">{found.properties.lw_table_pkid}</span
				>
			</div>
			{#if found.properties.status}
				<div class="device-property">
					<span class="property-label">Status:</span>
					<span class="property-value">{found.properties.status}</span>
				</div>
			{/if}
			{#if found.properties.tier}
				<div class="device-property">
					<span class="property-label">Voltage Regime:</span>
					<span class="property-value"
						>{#if found.properties.tier === 1}Primary
						{:else}
							Secondary{/if}</span
					>
				</div>
			{/if}
			{#if showMore}
				<div class="device-info">
					{#if displayed === "INFO"}
						<Info lw_id={found.properties.lw_id} />
					{/if}

					{#if displayed === "ENERGIZED"}
						<FindEnergized
							lw_id={found.properties.lw_id}
							status={found.properties.status}
							phase={found.properties.phase}
							iama={found.properties.iama}
							clkd={found.clicked}
							table={found.properties.lw_table}
						/>
					{/if}
					{#if displayed === "COMMENT"}
						<Comments 
							lw_id={found.properties.lw_id}
							iama={found.properties.iama}
							clkd={found.clicked}
							found={found}
						/>
					{/if}
					{#if displayed === "NRGY"}
						<Nrgy 
							energized={found.properties.energized}
							lw_id={found.properties.lw_id}
							feederid={found.properties.feederid}
						/>
					{/if}
				</div>
			{/if}
		</div>

		<div class="arrow-icon">
			{#if showMore}
				{#if displayed !== "ENERGIZED" && found.properties.status !== "ADJUNCT"}
					<span
						onclick={() => {
							display("ENERGIZED");
						}}
					>
						<Fa icon={faDiagramProject} size="1.5x" />
					</span>
				{/if}

				{#if displayed !== "COMMENT"}
					<span
						onclick={() => {
							display("COMMENT");
						}}
					>
						<Fa icon={faComments} size="1.5x" />
					</span>
				{/if}
				{#if displayed !== "INFO"}
					<span
						onclick={() => {
							display("INFO");
						}}
					>
						<Fa icon={faTableList} size="1.5x" />
					</span>
				{/if}
				{#if displayed !== "NRGY" && found.properties.status !== "ADJUNCT"}
					<span
						onclick={() => {
							display("NRGY");
						}}
					>
						<Fa icon={faPowerOff} size="1.5x" />
					</span>
				{/if}
			{/if}
			{#if !showMore && yyyy.outages}
				<span onclick={addToOutages} class="oplus-icon">
					<Fa icon={faPlus} size="1.5x" />
				</span>
			{/if}
			{#if !showMore && !yyyy.outages}
				<span onclick={expandMe}>
					<Fa icon={faArrowRight} size="1.5x" />
				</span>
			{/if}
		</div>
	</div>
{/if}

<style>
	.device-card {
		position: relative;
		border: 1px solid #dbdbdb;
		border-radius: 4px;
		background-color: #fff;
		transition:
			background-color 0.2s,
			box-shadow 0.2s;
		display: flex;
		flex-direction: column;
		width: 100%;
		max-height: 65vh;
	}

	.device-card:hover {
		background-color: #f5f5f5;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	}

	.device-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.75rem;
		font-weight: bold;
		border-bottom: 1px solid #eee;
		background-color: #fff;
		position: unset;
		top: 0;
		z-index: 1;
	}

	.device-content {
		flex: 1;
		overflow-y: auto;
		padding: 0.75rem;
		font-size: 0.9rem;
		margin-bottom: 25px;
	}

	.arrow-icon {
		position: absolute;
		bottom: 0.75rem;
		right: 0.75rem;
		color: #ff3e00;
		opacity: 0.7;
		transition: opacity 0.2s;
		cursor: pointer;
		z-index: 2;
		display: flex;
		gap: 0.5rem;
		padding: 0 0.25rem;
	}

	.device-card:hover .arrow-icon {
		opacity: 1;
	}
	
	.plus-icon {
		background-color: #48c774;
		color: white;
		border-radius: 50%;
		padding: 4px;
		margin-right: 5px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.device-label {
		color: #363636;
	}

	.device-phase {
		border-radius: 4px;
		padding: 0.1rem 0.5rem;
		font-size: 0.9rem;
		font-weight: 500;
		min-width: 32px;
		text-align: center;
		display: inline-block;
	}
	
	/* Phase color coding - matching SummaryView */
	.phase-a {
		background-color: rgba(152, 32, 19, 0.2);
		color: #982013;
	}
	
	.phase-b {
		background-color: rgba(25, 149, 12, 0.2);
		color: #19950c;
	}
	
	.phase-c {
		background-color: rgba(24, 51, 139, 0.2);
		color: #18338b;
	}
	
	.phase-ab {
		background: linear-gradient(135deg, rgba(152, 32, 19, 0.2) 50%, rgba(25, 149, 12, 0.2) 50%);
		color: #333;
	}
	
	.phase-ac {
		background: linear-gradient(135deg, rgba(152, 32, 19, 0.2) 50%, rgba(24, 51, 139, 0.2) 50%);
		color: #333;
	}
	
	.phase-bc {
		background: linear-gradient(135deg, rgba(25, 149, 12, 0.2) 50%, rgba(24, 51, 139, 0.2) 50%);
		color: #333;
	}
	
	.phase-abc {
		background: linear-gradient(135deg, 
			rgba(152, 32, 19, 0.2) 33%, 
			rgba(25, 149, 12, 0.2) 33%, 
			rgba(25, 149, 12, 0.2) 66%, 
			rgba(24, 51, 139, 0.2) 66%);
		color: #333;
	}
	
	.phase-unknown {
		background-color: #f0f0f0;
		color: #666;
	}

	.device-property {
		display: flex;
		margin-bottom: 0.25rem;
	}

	.property-label {
		color: #363636;
		margin-right: 0.5rem;
	}

	.property-value {
		color: #4a4a4a;
	}

	.id-value {
		color: #ff3e00;
	}

	.device-info {
		margin-top: 0.5rem;
	}
</style>
